import React from "react";
import { ReactComponent as WhatsappIcon } from "./assets/whatsapp.svg";

export const TemplateNameTile: React.FC<{ name: string; text: string }> = ({
  name,
  text,
}) => (
  <div className="flex max-w-[700px] items-center gap-4 px-4 py-5 whitespace-normal">
    <WhatsappIcon className="shrink-0 [transform:translateZ(0)] [will-change:transform] [backface-visibility:hidden]" />
    <div className="flex flex-col gap-0.5">
      <span className="font-secondary leading-[140%] font-medium tracking-[0.16px] text-dark-800">
        {name}
      </span>
      <span className="font-secondary leading-[140%] tracking-[0.14px] text-grey">
        {text}
      </span>
    </div>
  </div>
);
